import React from 'react';
import { connect } from 'react-redux';
import { useHistory, useLocation } from 'react-router';
import MercurXBackButton from '../../components/MercurXBackButton/MercurXBackButton';
import MercurXNftDetailInputs from '../../components/MercurXNftDetailInputs/MercurXNftDetailInputs';
import './EditNft.scss';

function EditNft() {
  const history = useHistory();
  const location = useLocation();
  const nft = location.state?.nft;

  if (!nft) {
    history.goBack();
    return null;
  }

  return (
    <div>
      <MercurXBackButton buttonText="Back to NFT list" />
      <div className="text-fs-head-sm">Edit NFT</div>
      <MercurXNftDetailInputs isEdit={true} />
    </div>
  );
}

export default connect(null, null)(EditNft);
